// extracted by mini-css-extract-plugin
export default {"title":"delete-confirmation-modal_title__wOkJD","subTitle":"delete-confirmation-modal_subTitle__Lpz0B"};